export default class State {
  constructor(props) {
    for (const key in props) {
      props[key] = new Observable(key, props[key]);
    }
    
    this.public = (() => {
      let state = Object.assign({}, props);

      for (const key in state) {
        Object.defineProperty(state, key, {
          get: () => props[key].value,
          set(v) {
            props[key].value = v
          }
        });
      }
      
      return state;
    })();

    Object.assign(this, props);
  }

  attach(name, component) {
    for (const key in this) {
      if (this[key].subscribe) {
        this[key].subscribe(name, component);
        this[key].notify(name);
      }
    }
  }
}

export class Observable {
  constructor(name, value) {
    this._value = value;
    this.name = name;
    this.subscribers = {};
  }

  subscribe(name, component) {
    this.subscribers[name] = component;
  }

  notify(name) {
    let component = this.subscribers[name];

    if (component) {
      component.props[this.name] = this._value;
      component.emit(`prop:${this.name}`, this._value);
    }
  }

  update() {
    Object.values(this.subscribers).forEach(component => {
      component.props[this.name] = this._value;
      component.emit(`prop:${this.name}`, this._value);
    });
  }

  get value() {
    return this._value;
  }

  set value(v) {
    if (v !== this._value) {
      this._value = v;
      this.update();
    } 
  }
}